export default __webpack_public_path__ + "static/media/blog-header.2d8d0d93.png";